import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import { trackOpenGoalsFromAttainment } from '../../../utils/usageTracker';
import { createNewGoalsUrl } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AttainmentBarNoGoalsTooltip = ({
  isDetailPage,
  subscreen,
  isDealStageView,
  teamId,
  isLoadingGoal = false
}) => /*#__PURE__*/_jsx(Tooltip, {
  maxInlineSize: "204px",
  title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "repOverviewTable.attainmentCell.tooltip.link_jsx",
    elements: {
      Link
    },
    options: {
      external: true,
      href: createNewGoalsUrl(),
      onClick: () => trackOpenGoalsFromAttainment({
        isDetail: isDetailPage,
        subscreen,
        isDealStageView,
        team: teamId
      })
    }
  }),
  placement: "right",
  disabled: isLoadingGoal,
  children: /*#__PURE__*/_jsx("span", {
    children: isLoadingGoal ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.cells.loadingGoals"
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.cells.noGoalsSet"
      }), /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        color: EERIE,
        className: "m-left-1"
      })]
    })
  })
});